<template>
  <div>
    <alter-request
      :requester="{ id: item.id, type: 'Container', attr: 'chassis_no' }"
    >
      {{ item.chassis_no }}
    </alter-request>
    <slot
      v-for="o in (item.transports || [])
        .flatMap((t) => t.operations || [])
        .filter((o) => ['swap', 'mount'].includes(o.mode))"
    >
      <alter-request
        :requester="{ id: o.id, type: 'Operation', attr: 'chassis_no' }"
        :key="o.id"
      >
        <div class="tag f90">{{ o.chassis_no }}</div>
      </alter-request>
    </slot>
  </div>
</template>

<script>
export default {
  name: "order-status-chassis-no",
  props: {
    item: Object,
    options: Object,
  },
};
</script>
